import React, {useEffect} from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Facility } from '../components/Facility';
import { faCreditCard, faGift, faRotate } from '@fortawesome/free-solid-svg-icons';

export const CustomerService = () => {

  useEffect(() => {
    document.title = 'Customer Service'; // Set the title to "Customer Service" when this component mounts
  }, []);
  return (
    <>
    <section className="customerservice">
        <div className="container py-5">
          <div className="row text-center py-5" data-aos="fade-down" data-aos-duration="1000">
            <h2 className="f-24 fw-700">Customer Service</h2>
          </div>

          <div className=''>
            <h3 className='f-18'> <FontAwesomeIcon icon={faGift} /> SHIPPING TIMES AND COSTS</h3>
            <ul className='mb-5 custom-ul-padding'>
              <li>Complimentary ground shipping within 1 to 7 business days</li>
              <li>In-store collection available within 1 to 7 business days</li>
              <li>Next-day and Express delivery options also available</li>
              <li>Purchases are delivered in an orange box tied with a Bolduc ribbon, with the exception of certain items</li>
              <li>See the delivery FAQs for details on shipping methods, costs and delivery times</li>  
            </ul>
            <h3 className='f-18'> <FontAwesomeIcon icon={faCreditCard} /> PAYMENT METHODS</h3>
            <p>
            Shella accepts the following payment methods:
            </p>
            <ul className='mb-5 custom-ul-padding'>
              <li>Credit Card: Visa, MasterCard, Discover, American Express, JCB, Visa Electron. The total will be charged to your card when the order is shipped.</li>
              <li>Shella features a Fast Checkout option, allowing you to securely save your credit card details so that you don't have to re-enter them for future purchases.</li>
              <li>PayPal: Shop easily online without having to enter your credit card details on the website.Your account will be charged once the order is completed. To register for a PayPal account, visit the website paypal.com.</li>
              
             
            </ul>
            <h3 className='f-18'> <FontAwesomeIcon icon={faRotate} /> EXCHANGES, RETURNS AND REFUNDS</h3>
            <p>Items returned within 14 days of their original shipment date in same as new condition will be eligible for a full refund or store credit. Refunds will be charged back to the original form of payment used for purchase. Customer is responsible for shipping charges when making returns and shipping/handling fees of original purchase is non-refundable.</p>
          </div>

        
        </div>
      </section>

      <Facility/>
    </>
  );
};